import { date } from './date';
import { kind } from './kind';
import { eventType } from './eventType';
import { message } from './message';

export const columns = [date, kind, eventType, message];
